import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import HouseholdIntakeGate from './HouseholdIntakeGate';

const PrivateRoute = ({ children }) => {
	const { authenticated, loading } = useAuth();
	const location = useLocation();

	if (loading) {
		return (
			<div>
				<LoadingSpinner />
			</div>
		);
	}

	if (!authenticated) {
		const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
		return <Navigate to={`/signin?returnTo=${returnTo}`} replace />;
	}

	return <HouseholdIntakeGate>{children}</HouseholdIntakeGate>;
};

export default PrivateRoute;
